import request from '../utils/request';
export function fetchCorporateGroups(filters) {
    const params = new URLSearchParams();
    const search = filters?.search?.trim();
    const isActive = filters?.is_active;
    if (search)
        params.append('search', search);
    if (isActive !== undefined)
        params.append('is_active', String(isActive));
    const queryString = params.toString();
    const url = queryString
        ? `/api/v1/admin/corporate-groups/?${queryString}`
        : '/api/v1/admin/corporate-groups/';
    return request()
        .get(url)
        .send();
}
export function createCorporateGroup(payload) {
    return request()
        .post('/api/v1/admin/corporate-groups/')
        .send(payload);
}
export function updateCorporateGroup(id, payload) {
    return request()
        .patch(`/api/v1/admin/corporate-groups/${id}/`)
        .send(payload);
}
export function deleteCorporateGroup(id) {
    return request()
        .delete(`/api/v1/admin/corporate-groups/${id}/`)
        .send();
}
